import * as React from 'react';
import {Component, I18NString } from "../Utils";
import { isUndefined } from 'lodash';

interface Props {
    id: string;
    required: boolean;
    contentNumb: string;
    title: I18NString;
    status?: string;
    disabled?: boolean;
    disableNumber?: boolean;
    fullwidth?: boolean,
    bordered?: boolean,
    className?: string,
    helpBtn?: any,
}

class Field extends Component<Props,{}>{
    defaultProps :{
        status: "default"
    }

    getStateGroup() : string {
        let className = this.props.className || '' + " form-group";
        if(isUndefined(this.props.disabled) && !this.props.disabled){
            switch(this.props.status){
                case "error":  className += " has-error";
                    break;
                case "success": className += " has-success";
                    break
                default: className = this.props.className || '' + " form-group";
                    break;
            }

            return className;
        }

        return className

    }

    render(){
        const { id,  required, title, contentNumb, disableNumber, helpBtn } = this.props;
        //let label_classname = "col-xs-12 col-sm-6 col-md-6 col-lg-5"
        //let content_classname = "col-xs-12 col-sm-6 col-md-6 col-lg-7"
        //if(this.props.fullwidth === true){
            let label_classname = "col-xs-12 fullwidth"
            let content_classname = "col-xs-12"
        //}
        if(this.props.bordered === true){
            label_classname += " label--bordered"
        }
        return(
            <div id={id} className={this.getStateGroup()}>
                <div className={label_classname}>
                    <label className="control-label">
                        <div className="reportbox-content-num">{(disableNumber) ? '' : contentNumb }</div>
                        <div className={required ? "reportbox-content-desc required" : "reportbox-content-desc"} dangerouslySetInnerHTML={{__html: this.tr(title) }} />
                        {helpBtn || ''}
                    </label>
                </div>
                <div className={content_classname}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Field;
